import { calculateCalibrationTotals } from 'src/app/Shared/calibration-invoice-totals';
import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import { finalize } from 'rxjs/operators';
import * as XLSX from 'xlsx';
import { invoiceSummaryRows } from 'src/app/Shared/invoice-totals';
import {
  CalibrationConfirmInvoiceApiResponse,
  CalibrationConfirmInvoiceDeviceModel,
  CalibrationConfirmInvoiceModel
} from 'src/app/Interface/CalibrationConfirmInvoice_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CalibrationConfirmInvoiceService } from 'src/app/Service/CalibrationConfirmInvoice.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { buildCalibrationFactorRows } from 'src/app/Shared/calibration-factor-rows';
import {
  calculateCalibrationFinalTotal2,
  calculateCalibrationFinalUnitPrice,
  calculateCalibrationInvoiceTotal,
  calculateCalibrationUnitPrice
} from 'src/app/Shared/calibration-confirm-invoice-price';

@Component({
  selector: 'app-letterrequestcustomer-factor2-form',
  templateUrl: './LetterrequestcustomerFactor2Form.component.html',
  styleUrls: ['../CalibrationConfirmInvoice/CalibrationConfirmInvoiceForm.component.scss']
})
export class LetterrequestcustomerFactor2FormComponent implements OnInit {
  @ViewChild('factorPdfContent') factorPdfContent?: ElementRef<HTMLElement>;

  calibrationId = 0;
  receipt: CalibrationConfirmInvoiceModel | null = null;
  details: CalibrationConfirmInvoiceDeviceModel[] = [];
  factorRows: CalibrationConfirmInvoiceDeviceModel[] = [];
  takhfif = 0;
  arshAfzoodeh = 0;
  khadamat = 0;
  totals = calculateCalibrationTotals([], 0, 0, 0);
  loading = false;
  pdfProcessing = false;
  excelProcessing = false;
  factorConfirming = false;
  factorConfirmModalRef: any;

  constructor(
    private route: ActivatedRoute,
    private service: CalibrationConfirmInvoiceService,
    private Nav_Service: NavService,
    private alertifyService: AlertifyService,
    private modalService: BsModalService
  ) { }

  ngOnInit(): void {
    this.calibrationId = Number(this.route.snapshot.paramMap.get('id'));
    this.receipt = history.state && history.state.receipt ? history.state.receipt : null;
    if (!this.calibrationId) {
      this.alertifyService.ErrorMessage('شماره رسید معتبر نیست.');
      return;
    }

    this.Nav_Service.CheckValidPage(2226).subscribe(
      () => {
        this.readDetail();
        if (!this.receipt) {
          this.readReceipt();
        }
      },
      () => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    );
  }

  readDetail(): void {
    this.loading = true;
    this.service.GetInvoiceDetail(this.calibrationId)
      .pipe(finalize(() => this.loading = false))
      .subscribe(
        response => {
          this.details = response.devices;
          this.takhfif = response.takhfif;
          this.arshAfzoodeh = response.arshAfzoodeh;
          this.khadamat = response.khadamat;
          this.factorRows = this.buildFactorRows(this.details);
          this.calculateTotals();
          this.totals = response.totals;
        },
        () => this.alertifyService.ErrorMessage('دریافت جزئیات رسید با خطا مواجه شد.')
      );
  }

  getUnitPrice(item: CalibrationConfirmInvoiceDeviceModel): number {
    return calculateCalibrationUnitPrice(item);
  }

  getInvoiceTotal(item: CalibrationConfirmInvoiceDeviceModel): number {
    return calculateCalibrationInvoiceTotal(item);
  }

  getFinalUnitPrice(item: CalibrationConfirmInvoiceDeviceModel): number {
    return calculateCalibrationFinalUnitPrice(item);
  }

  getFinalTotal(item: CalibrationConfirmInvoiceDeviceModel): number {
    return calculateCalibrationFinalTotal2(item);
  }

  getFinalGrandTotal(): number {
    return this.totals.finalTotal;
  }

  calculateTotals(): void {
    // Details represent individual devices; grouped rows multiply the unit price by group count.
    this.totals = calculateCalibrationTotals(this.details, this.khadamat, this.takhfif, this.arshAfzoodeh);
  }

  getInvoiceGrandTotal(): number {
    return this.factorRows.reduce((total, item) => total + this.getInvoiceTotal(item), 0);
  }

  buildFactorRows(details: CalibrationConfirmInvoiceDeviceModel[]): CalibrationConfirmInvoiceDeviceModel[] {
    return buildCalibrationFactorRows(details);
  }

  get isFactorConfirmed(): boolean {
    return !!(this.receipt?.factorConfirmDate || this.receipt?.factorConfirmDatePersian);
  }

  openFactorConfirmModal(template: TemplateRef<any>): void {
    if (this.factorConfirming || this.isFactorConfirmed || !this.calibrationId) {
      return;
    }

    this.factorConfirmModalRef = this.modalService.show(template);
  }

  confirmFactor(): void {
    if (this.factorConfirming || this.isFactorConfirmed || !this.calibrationId) {
      return;
    }

    this.factorConfirmModalRef.hide();
    this.factorConfirming = true;
    this.service.ConfirmFactor(this.calibrationId)
      .pipe(finalize(() => this.factorConfirming = false))
      .subscribe(
        () => {
          this.alertifyService.SuccessMessage('فاکتور با موفقیت ثبت شد.');
          this.readReceipt();
        },
        () => this.alertifyService.ErrorMessage('ثبت نهایی فاکتور با خطا مواجه شد.')
      );
  }

  async exportPdf(): Promise<void> {
    if (this.pdfProcessing || this.loading || !this.factorPdfContent) {
      return;
    }

    this.pdfProcessing = true;
    this.calculateTotals();
    try {
      if (document.fonts?.ready) {
        await document.fonts.ready;
      }
      await this.waitForRender();
      const element = this.factorPdfContent.nativeElement;
      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        backgroundColor: '#ffffff',
        logging: false,
        width: element.scrollWidth,
        height: element.scrollHeight,
        windowWidth: element.scrollWidth,
        windowHeight: element.scrollHeight
      });

      const pdf = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
      const margin = 8;
      const printableWidth = pdf.internal.pageSize.getWidth() - margin * 2;
      const printableHeight = pdf.internal.pageSize.getHeight() - margin * 2;
      const maxSliceHeight = Math.floor(canvas.width * printableHeight / printableWidth);
      const scaleY = canvas.height / element.scrollHeight;
      const elementTop = element.getBoundingClientRect().top;
      const boundaries = Array.from(element.querySelectorAll('.device-card, .factor-summary'))
        .map(section => Math.round((section.getBoundingClientRect().bottom - elementTop) * scaleY))
        .filter(boundary => boundary > 0 && boundary < canvas.height);

      let sourceY = 0;
      let pageNumber = 0;
      while (sourceY < canvas.height) {
        const targetY = Math.min(sourceY + maxSliceHeight, canvas.height);
        const safeBoundary = boundaries.filter(value => value > sourceY && value <= targetY).pop();
        const sourceEnd = targetY < canvas.height && safeBoundary ? safeBoundary : targetY;
        const sliceHeight = Math.max(1, sourceEnd - sourceY);
        const pageCanvas = document.createElement('canvas');
        pageCanvas.width = canvas.width;
        pageCanvas.height = sliceHeight;
        const context = pageCanvas.getContext('2d');
        if (!context) {
          throw new Error('PDF canvas context is unavailable');
        }
        context.fillStyle = '#ffffff';
        context.fillRect(0, 0, pageCanvas.width, pageCanvas.height);
        context.drawImage(canvas, 0, sourceY, canvas.width, sliceHeight, 0, 0, canvas.width, sliceHeight);
        if (pageNumber > 0) {
          pdf.addPage('a4', 'landscape');
        }
        pdf.addImage(
          pageCanvas.toDataURL('image/jpeg', 0.96),
          'JPEG',
          margin,
          margin,
          printableWidth,
          sliceHeight * printableWidth / canvas.width
        );
        sourceY = sourceEnd;
        pageNumber++;
      }
      pdf.save(`LetterRequestCustomerFactor-${this.getDocumentNumber()}.pdf`);
    } catch (error) {
      console.error('Letter request customer factor PDF export failed', error);
      this.alertifyService.ErrorMessage('خطا در ایجاد فایل PDF');
    } finally {
      this.pdfProcessing = false;
    }
  }

  exportExcel(): void {
    if (this.excelProcessing || this.loading) {
      return;
    }

    this.excelProcessing = true;
    this.calculateTotals();
    try {
      const rows = this.factorRows.map((item, index) => ({
        'ردیف': index + 1,
        'نام دستگاه انگلیسی': item.deviceTitle || '',
        'نام دستگاه فارسی': item.deviceName || '',
        'محل کالیبراسیون': item.locationName || '',
        'تعداد': this.toNumber(item.count),
        'قیمت واحد پایه (ریال)': this.getUnitPrice(item),
        'تعرفه اضافه تجهیز (درصد)': this.toNumber(item.incRailPercent),
        'تعرفه اضافه تجهیز (ریال)': this.toNumber(item.incRail),
        'قیمت واحد نهایی (ریال)': this.getFinalUnitPrice(item),
        'قیمت کل (ریال)': this.getFinalTotal(item),
        'توضیحات': item.description || item.priceDescription || '',
        'توضیحات تأیید کار و پیش‌فاکتور': item.confirmInvoiceDescription || ''
      }));
      const worksheet = XLSX.utils.json_to_sheet(rows);
      const summaryStart = XLSX.utils.decode_range(worksheet['!ref'] || 'A1').e.r + 1;
      XLSX.utils.sheet_add_aoa(worksheet, invoiceSummaryRows(this.totals), { origin: -1 });
      Object.keys(worksheet).filter(key => key[0] !== '!').forEach(key => {
        if (worksheet[key].t === 'n') worksheet[key].z = '#,##0.###';
      });
      [1, 4].forEach(offset => {
        worksheet[XLSX.utils.encode_cell({ r: summaryStart + offset, c: 1 })].z = '0.###"%"';
      });
      worksheet['!cols'] = [
        { wch: 8 }, { wch: 28 }, { wch: 28 }, { wch: 20 },
        { wch: 10 }, { wch: 20 }, { wch: 18 }, { wch: 18 },
        { wch: 20 }, { wch: 20 }, { wch: 40 }
      ];
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Factor');
      XLSX.writeFile(workbook, `LetterRequestCustomerFactor-${this.getDocumentNumber()}.xlsx`);
    } catch (error) {
      console.error('Letter request customer factor Excel export failed', error);
      this.alertifyService.ErrorMessage('خطا در ایجاد فایل Excel');
    } finally {
      this.excelProcessing = false;
    }
  }

  private readReceipt(): void {
    this.service.GetConfirmed(-1).subscribe(
      response => {
        this.receipt = this.unwrap(response).find(item => item.calibrationId === this.calibrationId) || null;
      },
      () => { }
    );
  }

  private getDocumentNumber(): string {
    return this.sanitizeFileName(this.receipt?.code || this.calibrationId);
  }

  private waitForRender(): Promise<void> {
    return new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(() => resolve())));
  }

  private sanitizeFileName(value: unknown): string {
    return String(value || this.calibrationId)
      .replace(/[<>:"/\\|?*\u0000-\u001F]/g, '-')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  private toNumber(value: number | null | undefined): number {
    const number = Number(value);
    return isFinite(number) ? number : 0;
  }

  private unwrap<T>(response: T[] | CalibrationConfirmInvoiceApiResponse<T[]>): T[] {
    if (Array.isArray(response)) {
      return response;
    }
    return response && Array.isArray(response.result) ? response.result : [];
  }
}
